import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setTemplateModalData } from '../store/actions/housingStockActions';

const useChangeTemplateModalVisible = () => {
  const dispatch = useDispatch();

  const open = useCallback(
    (data) => {
      dispatch(setTemplateModalData(data));
    },
    [dispatch]
  );

  const close = useCallback(() => {
    dispatch(setTemplateModalData(null));
  }, [dispatch]);

  return { open, close };
};

export default useChangeTemplateModalVisible;